module.exports = __webpack_public_path__ + "img/16l010-11.53b96805.jpg";